<template>
    <el-scrollbar class="hot-video">
        <div class="head-box">
            <!--筛选条件-->
            <div class="category-list">
                <div class="cate-left">分类：</div>
                <div class="cate-content">
                    <template v-for="(cateItem, cateIndex) in typeList">
                        <div
                            class="cate-item"
                            @click="chooseTag(cateItem)"
                            :class="cateItem | categoryStyle(params.star_category)"
                            :key="`categoryList_${cateIndex}`"
                        >
                            {{ cateItem }}
                        </div>
                    </template>
                </div>
            </div>
            <!-- <div class="filter-box"></div>
            <div class="time-box" style="padding-bottom: 20px; padding-left: 20px">
                <div class="day-type">
                    <el-radio-group class="radio-group" v-model="params.day_type" size="small" @change="getListByTime">
                        <el-radio-button label="hour">小时榜</el-radio-button>
                        <el-radio-button label="day">日榜</el-radio-button>
                        <el-radio-button label="week">周榜</el-radio-button>
                        <el-radio-button label="month">月榜</el-radio-button>
                    </el-radio-group>
                </div>
                <div class="time-filter-box">
                    <el-select class="list-type-box" size="mini" v-model="params.day" placeholder="请选择" @change="getAllClass()">
                        <el-option v-for="item in currentListType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                <el-input
                    clearable
                    @change="getAllClass(false)"
                    prefix-icon="el-icon-search"
                    class="el-int"
                    placeholder="请输入视频名称"
                    v-model="keyword"
                    size="small"
                ></el-input>
            </div> -->
        </div>

        <el-table
            :data="fullTaskList"
            class="college-table"
            size="medium"
            v-el-table-infinite-scroll="load"
            :header-cell-style="{ fontWeight: 'Regular', color: '#333', background: '#fff' }"
            :cell-style="{ fontSize: '12px', color: '#333' }"
            :default-sort="{ prop: defalutSort.prop, order: defalutSort.order }"
            @sort-change="sortChange"
            ref="multipleTable"
        >
            <el-table-column prop="task_id" label="视频作品" align="left" class-name="student-name">
                <template slot-scope="scope">
                    <div @click="changeToDetail(scope.row)" class="videoBox" style="display: flex; cursor: pointer">
                        <div class="picBox">
                            <img style="width: 90px; height: 120px" :src="scope.row.aweme_cover" />
                        </div>
                        <div class="right-row-content">
                            <div style="font-size: 14px">{{ scope.row.aweme_title }}</div>
                            <div class="hot-word-content"></div>
                            <div>
                                <span>视频时长：</span>
                                <span>{{ Math.floor(scope.row.duration / 1000) }}秒</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="nickname" width="200" label="播主" align="center" class-name="student-name">
                <template slot-scope="scope">
                    <p class="student-name-title">{{ scope.row.nickname }}</p>
                    <p class="student-name-title">{{ scope.row.aweme_create_time }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="digg_count" width="150" label="点赞总数" align="center" class-name="student-name" sortable="custom">
                <template slot-scope="scope">
                    <span class="student-name-title">{{ scope.row.digg_count }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="comment_count" width="150" label="评论总数" align="center" class-name="student-name" sortable="custom">
                <template slot-scope="scope">
                    <span class="student-name-title">{{ scope.row.comment_count }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="share_count" width="150" label="转发总数" align="center" class-name="student-name" sortable="custom">
                <template slot-scope="scope">
                    <span class="student-name-title">{{ scope.row.share_count }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="share_count" width="150" label="播放量" align="center" class-name="student-name" sortable="custom">
                <template slot-scope="scope">
                    <span class="student-name-title">{{ scope.row.play_count }}</span>
                </template>
            </el-table-column> -->
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <div class="table-operate">
                        <!-- 数据分析 -->
                        <svg
                            t="1739936072960"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="30524"
                            width="36"
                            height="36"
                            @click="changeToDetail(scope.row)"
                        >
                            <path
                                d="M0 0m512 0l0 0q512 0 512 512l0 0q0 512-512 512l0 0q-512 0-512-512l0 0q0-512 512-512Z"
                                fill="#006EFF"
                                p-id="30525"
                            ></path>
                            <path
                                d="M719.658667 256H322.218667C281.6 256 256 281.514667 256 322.218667v298.026666c0 40.704 25.514667 66.304 66.218667 66.304h397.44c40.704 0 66.176-25.6 66.176-66.304V322.218667c0-40.704-25.472-66.218667-66.133334-66.218667z m33.066666 357.333333c0 27.648-13.141333 40.021333-41.386666 40.021334H330.453333c-28.288 0-41.386667-12.373333-41.386666-40.021334V329.130667c0-27.605333 13.098667-40.064 41.386666-40.064h380.8c28.288 0 41.386667 12.458667 41.386667 40.064v284.16h0.042667z m-397.397333 147.712c0-4.821333 3.498667-8.32 8.32-8.32h314.581333c4.778667 0 8.32 3.498667 8.32 8.32v16.554667a8.021333 8.021333 0 0 1-8.32 8.234667H363.605333a7.978667 7.978667 0 0 1-8.277333-8.234667v-16.554667z"
                                fill="#FFFFFF"
                                p-id="30526"
                            ></path>
                            <path
                                d="M354.730667 485.333333c-3.413333-2.773333-2.773333-8.96 1.365333-13.141333l78.677333-78.592c4.138667-4.138667 10.325333-4.864 13.098667-1.365333l11.733333 11.690666c3.413333 2.773333 2.730667 8.96-1.365333 13.098667l-78.677333 78.677333c-4.096 4.096-10.325333 4.821333-13.098667 1.365334l-11.733333-11.733334z m218.666666 50.218667c-3.456-4.138667-1.408-9.642667 2.773334-13.824l84.906666-70.997333c4.736-3.498667 11.050667-4.138667 13.738667-0.725334l10.325333 12.373334c3.498667 4.224 1.408 9.685333-2.730666 13.824l-84.906667 71.082666c-4.778667 3.413333-11.008 4.138667-13.781333 0.64l-10.325334-12.373333z"
                                fill="#FFFFFF"
                                p-id="30527"
                            ></path>
                            <path
                                d="M438.613333 394.965333c2.773333-4.138667 8.277333-4.138667 11.733334-1.365333l152.490666 127.658667c3.413333 2.773333 3.413333 8.277333 0.682667 11.690666l-10.410667 12.416c-2.730667 4.138667-8.234667 4.138667-11.690666 1.365334l-152.448-127.573334c-3.413333-2.773333-3.413333-8.32-0.682667-11.776l10.325333-12.373333z"
                                fill="#FFFFFF"
                                p-id="30528"
                            ></path>
                        </svg>

                        <!-- 播放 -->
                        <svg
                            t="1739935652413"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="4981"
                            width="36"
                            height="36"
                            @click="jumpToVideo(scope.row)"
                        >
                            <path
                                d="M512 0C228.072727 0 0 228.072727 0 512s228.072727 512 512 512 512-228.072727 512-512S795.927273 0 512 0z m193.163636 563.2l-218.763636 125.672727c-39.563636 23.272727-88.436364-4.654545-88.436364-51.2V386.327273c0-44.218182 48.872727-72.145455 88.436364-51.2l218.763636 125.672727c37.236364 23.272727 37.236364 79.127273 0 102.4z"
                                p-id="4982"
                                fill="#F56C6C"
                            ></path>
                        </svg>
                    </div>
                </template>
            </el-table-column>
            <template #append>
                <div class="scroll-hint" v-if="showScrollLoading">{{ scrollHint }}</div>
            </template>
        </el-table>
        <div class="page-content"></div>
    </el-scrollbar>
</template>

<script>
import { HOTVIDEO, defaultDay } from "@/utils/staticData";

let _this;
export default {
    name: "HotVideo",
    data() {
        return {
            keyword: "",
            isAll: 0,
            day_type: "day",
            tag: "全部", //分类名称
            typeList: [], //分类列表
            task_condition: "",
            taskList: [], //任务列表
            digg: -1, //点赞区间
            diggOptions: HOTVIDEO.diggOptions,
            duration: -1, //视频时长
            durationOptions: HOTVIDEO.durationOptions,
            gender_type: -1, //男女比例
            genderOptions: HOTVIDEO.genderOptions,
            age_type: -1,
            ageOptions: HOTVIDEO.ageOptions,
            //分页
            adminPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            sort: {
                type: "",
                order: "",
            },
            order: "",
            params: {
                day_type: "day",
                day: "",
                order_by: "digg_count",
                order_sort: "",
                star_category: "",
                page: 0,
                size: 10,
            },
            timer: -1,
            flag: true,
            showScrollLoading: false,
            timeFilterOptions: HOTVIDEO.timeFilterOptions,
            loading: true,
            loadMore: false,
            defalutSort: { prop: "", order: "" },
        };
    },
    created() {
        this.initType();
    },
    mounted() {
        _this = this;
        this.getTaskType();
        this.getAllClass();
    },
    computed: {
        /**滚动提示语 */
        scrollHint() {
            return "加载中...";
        },
        /** 经过筛选显示在页面的列表 */
        fullTaskList() {
            let { sort, taskList } = this;
            let newList = [...taskList];
            // if (sort.order) {
            //     let key = sort.type;
            //     let sortFun =
            //         sort.order == "descending" ? (before, after) => before[key] - after[key] : (before, after) => after[key] - before[key];
            //     newList = newList.sort(sortFun);
            // }
            return newList;
        },
        /**当前的榜单 */
        currentListType() {
            let { day_type } = this.params;
            return this.timeFilterOptions[day_type];
        },
    },
    filters: {
        /** 判断选中的分类tag */
        categoryStyle(item, nowTag) {
            return {
                current: item == nowTag || (item == "全部" && nowTag == ""),
            };
        },
    },
    watch: {
        "params.day_type": {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.params.day = newVal === "day" ? defaultDay() : this.currentListType[0].value;
                }
            },
            immediate: true,
        },
    },
    methods: {
        // 初始化类型
        initType() {
            const data_type = Number(this.$route.query.data_type);

            if (data_type === 17) {
                this.defalutSort = {
                    prop: "digg_count",
                    order: "descending",
                };
                this.params.order_by = "digg_count";
                this.params.order_sort = "desc";
            } else if (data_type === 18) {
                this.defalutSort = {
                    prop: "digg_count",
                    order: "descending",
                };
                this.params.order_by = "digg_count";
                this.params.order_sort = "desc";
            } else if (data_type === 19) {
                this.defalutSort = {
                    prop: "comment_count",
                    order: "descending",
                };
                this.params.order_by = "comment_count";
                this.params.order_sort = "desc";
            } else if (data_type === 20) {
                this.defalutSort = {
                    prop: "share_count",
                    order: "descending",
                };
                this.params.order_by = "share_count";
                this.params.order_sort = "desc";
            } else if (data_type === 21) {
                this.params.star_category = "母婴亲子";
            } else if (data_type === 22) {
                this.params.star_category = "才艺技能";
            } else if (data_type === 23) {
                this.params.star_category = "科技数码";
            } else if (data_type === 24) {
                this.params.star_category = "情感";
            }
        },
        load() {
            if (this.loadMore) {
                this.loading = true;
                this.showScrollLoading = true;
                this.timer && window.clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    _this.getAllClass(true);
                }, 500);
            }
        },
        toggleDayType(e) {
            this.params.day = e;
        },
        getTaskType() {
            this.$shttp.axiosGet(this.$api.video_category, (res) => {
                if (res.code === 200) {
                    this.typeList = res.data;
                } else {
                    this.$message.warning(res.message);
                }
            });
        },
        chooseTag(item) {
            // this.tag = item
            this.adminPages.currentPageNum = 1;
            this.params.star_category = item == "全部" ? "" : item;
            this.getAllClass();
        },
        getListByTime() {
            this.getAllClass();
        },
        // 获取全部视频列表
        getAllClass(isAppend = false) {
            if (this.flag) {
                this.flag = false;
                this.loading = false;
                this.loadMore = false;
                let { params } = this;

                params.page = isAppend ? params.page + 1 : 1;
                params.keyword = this.keyword;

                this.$shttp.axiosGetBy(this.$api.video_list, params, (res) => {
                    if (res.code == 200) {
                        if (res.data.length > 0 && res.data.length >= this.params.size) {
                            this.loadMore = true;
                        }

                        this.taskList = isAppend ? this.taskList.concat(res.data) : res.data;
                        if (!isAppend) {
                            this.$nextTick(() => {
                                this.$refs["multipleTable"].bodyWrapper.scrollTop = 0;
                            });
                        }

                        this.showScrollLoading = false;
                        this.loading = false;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message,
                            duration: 1000,
                        });
                    }
                    this.flag = true;
                });
            }
        },
        //分页
        adminCurrentChange(val) {
            this.adminPages.currentPageNum = val;
            this.getAllClass();
        },
        //跳到详情页
        changeToDetail(row) {
            this.$router.push({
                path: "/training/hotVideoDetail",
                query: {
                    aweme_id: row.aweme_id,
                    author_id: row.author_id,
                },
            });
        },
        //打开视频
        jumpToVideo(row) {
            window.open(row.aweme_url);
        },
        //排序handler
        sortChange({ prop, order }) {
            console.log("sort change: ", prop, order);
            // this.sort.type = prop;
            // this.sort.order = order;
            this.params.order_by = prop;
            this.params.page = 0;

            if (order === "ascending") this.params.order_sort = "asc";
            else if (order === "descending") this.params.order_sort = "desc";
            else this.params.order_sort = "";

            this.getAllClass();
        },
    },
};
</script>

<style lang="scss" scoped>
.hot-video {
    height: 100%;
    padding-block: 20px;
    box-sizing: border-box;

    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .el-int {
        width: 250px;
        margin-left: 20px;
    }
    .activeClass {
        background: #2338e6;
        color: #ffffff;
    }

    .head-box {
        background: #fff;
        margin-inline: 130px;
    }

    .category-list {
        display: flex;
        padding-top: 20px;
        margin: 0 20px 20px;
        // border-bottom: 1px solid #dcdfe6;

        .cate-left {
        }

        .cate-content {
            width: 1%;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            margin-left: -12px;

            .cate-item {
                padding: 0 8px;
                margin: 0 0 10px 12px;
                border: 1px solid transparent;
                cursor: pointer;

                &.current {
                    border-color: #1e33e3;
                    color: #1e33e3;
                }
            }
        }
    }

    .time-box {
        display: flex;
        align-items: center;
        .day-type {
            margin-right: 30px;
        }
        .radio-group {
            ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                background-color: #2338e6;
                border-color: #2338e6;
            }

            ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
                color: #fff;
            }

            ::v-deep .el-radio-button__inner:hover {
                color: #2338e6;
            }
        }
    }

    .el-table {
        margin-top: 20px;
        width: calc(100% - 260px);
        margin-left: 130px;

        ::v-deep .el-table__body-wrapper {
            height: calc(100vh - 280px) !important;
            overflow-x: hidden;

            /* 设置滚动条的宽度 */
            &::-webkit-scrollbar {
                width: 8px; /* 垂直滚动条宽度 */
                height: 8px; /* 水平滚动条高度 */
            }

            /* 设置滚动条轨道样式 */
            &::-webkit-scrollbar-track {
                background-color: transparent; /* 轨道颜色 */
                border-radius: 8px;
            }

            /* 设置滚动条滑块样式 */
            &::-webkit-scrollbar-thumb {
                background-color: #d2d3d5cc; /* 滑块颜色 */
                border-radius: 8px;
            }

            /* 滑块悬停时的样式 */
            &::-webkit-scrollbar-thumb:hover {
                background-color: #bfc1c4; /* 悬停时的颜色 */
            }
        }

        &:hover {
            ::v-deep .el-table__body-wrapper {
                overflow-x: auto;
            }
        }

        .table-operate {
            display: flex;
            align-content: center;
            justify-content: center;
            gap: 6px;

            svg {
                cursor: pointer;
                width: 30px;
                height: 30px;
            }
        }
    }

    .page-content {
        background: #fff;
    }

    .right-row-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
    }

    .filter-box {
        display: flex;
        // margin-bottom: 20px;

        .filter-item {
            margin-left: 20px;

            .light-title {
                color: #a4a4a4;
            }
        }
    }

    .operation-content {
        display: flex;
        justify-content: center;
    }

    .scroll-hint {
        padding: 12px;
        font-size: 14px;
        text-align: center;
    }
}
</style>
